import Product from './blocks/Product'
import ProductList from './blocks/ProductList'

export const dynamicBlocks = {
  product: Product,
  productList: ProductList
}
